import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '@/views/payroll/directive.js';
import Org from '@/components/organization';
import { applyDeyail as _applyDeyail, applyAdd, applyEdit } from 'api/approval/config';
import rules from './rule';
import { all, half, defaultSettings, otRuleTaps, timeInterval } from '../enmu';
import formItem from './form.vue';
export default {
  components: {
    Org: Org,
    formItem: formItem
  },
  props: {
    type: {
      type: String,
      default: 'add'
    },
    applyId: {
      default: ''
    }
  },
  mixins: [rules],
  data: function data() {
    return {
      visible: false,
      orgVisible: false,
      // 人员组织组件visible
      activeName: otRuleTaps[0],
      // taps value
      otRuleTaps: otRuleTaps,
      // taps enmu
      // 时间选择option负责
      form: {
        is_default: '0',
        // 是否是默认加班规则
        name: '',
        time_format: 1,
        // 申请时间格式1 不限制 2 只能选择整点/半点
        // 适用范围
        department_ids: [],
        staff_ids: [],
        selectedFormate: '',
        // 已选范围formate文案
        settings: defaultSettings()
      }
    };
  },
  computed: {
    title: function title() {
      return this.type === 'add' ? this.$t('132') : this.$t('71');
    },
    // 日期组件picker options
    timeOption: function timeOption() {
      return this.time_format === 1 ? all : half;
    },
    // 生成已选文案
    // @example 张三等3个人 法务部等10个部门
    selectedFormate: function selectedFormate() {
      if (this.form.is_default !== '0') return this.$t('1707');
      var _this$form = this.form,
        staff_ids = _this$form.staff_ids,
        department_ids = _this$form.department_ids;
      var staffStart = staff_ids[0];
      var departStart = department_ids[0];
      var staffText = staffStart ? staffStart.staff_name + (staff_ids.length > 1 ? this.$t('1653', {
        x: staff_ids.length
      }) : '') : '';
      var departText = departStart ? (staffText ? ', ' : '') + departStart.department_name + (department_ids.length > 1 ? this.$t('1654', {
        x: department_ids.length
      }) : '') : '';
      return staffText + departText;
    }
  },
  watch: {
    selectedFormate: function selectedFormate(v) {
      this.form.selectedFormate = v;
    }
  },
  methods: {
    handlerChangeState: function handlerChangeState(key, value) {
      this.form.settings[key] = value;
    },
    // 获取数据
    applyDeyail: function applyDeyail() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$_applyDeyail, data, staffs;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _applyDeyail({
                id: _this.applyId
              });
            case 2:
              _yield$_applyDeyail = _context.sent;
              data = _yield$_applyDeyail.data;
              staffs = [];
              if (Array.isArray(data.staff_ids)) {
                data.staff_ids.forEach(function (item) {
                  staffs.push({
                    staff_id: item.staff_id,
                    staff_name: item.staff_name,
                    staff_name_en: item.staff_name_en,
                    staff_name_secondary: item.staff_name_secondary,
                    staff_name_th: item.staff_name_th,
                    avatar_url: item.avatar_url
                  });
                });
              }
              data.staff_ids = staffs;
              Object.assign(_this.form, data);
              _this.formateDataShow();
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 数据格式化回显
    // '19:20-20:20 分解成俩个值 或者给定默认值'
    formateDataShow: function formateDataShow() {
      var settings = this.form.settings;
      otRuleTaps.forEach(function (item) {
        var allow_apply_time_frame = settings[item].allow_apply_time_frame;
        // 可选申请范围回显
        if (allow_apply_time_frame) {
          var times = allow_apply_time_frame.split('-');
          settings[item].start = times[0];
          settings[item].end = times[1];
        }
        // 休息时段回显
        var period = settings[item].rest_time_period;
        // 如果为空则创建一条默认值
        if (!period.length) {
          return settings[item].rest_time_period_formate = [timeInterval(true)];
        }
        // 不为空则回显
        settings[item].rest_time_period_formate = [];
        period.forEach(function (el) {
          var times = el.split('-');
          settings[item].rest_time_period_formate.push({
            start: times[0],
            end: times[1]
          });
        });
      });
    },
    // 关闭
    handleClose: function handleClose() {
      this.$emit('close');
    },
    // 打开Org选择
    openOrg: function openOrg() {
      if (this.form.is_default === '0') this.orgVisible = true;
    },
    // 适用范围人员选择
    handleSelectDepart: function handleSelectDepart(selectedOrg) {
      var staff_list = selectedOrg.staff_list,
        dept_list = selectedOrg.dept_list;
      this.form.staff_ids = staff_list;
      this.form.department_ids = dept_list;
    },
    // 存储前时段格式化
    formateInterval: function formateInterval() {
      var _this2 = this;
      // 时段格式化
      otRuleTaps.map(function (item) {
        var itemObj = _this2.form.settings[item];
        var rest_time_period_formate = itemObj.rest_time_period_formate;
        itemObj.allow_apply_time_frame = "".concat(itemObj.start, "-").concat(itemObj.end);
        itemObj.rest_time_period = rest_time_period_formate.map(function (el) {
          return "".concat(el.start, "-").concat(el.end);
        });
      });
    },
    // 存储
    handldSave: function handldSave() {
      var _this3 = this;
      var request = this.type === 'add' ? applyAdd : applyEdit;
      this.formateInterval();
      this.$refs.form.validate(function (valid) {
        if (valid) {
          request(_this3.form).then(function (res) {
            _this3.handleClose();
            _this3.$emit('updateList');
            _this3.$message.success(_this3.$t('160'));
          });
        }
      });
    }
  }
};